<!-- components/ToastAlert.vue -->
<template>
  <transition name="toast">
    <div v-if="isVisible" class="toast-alert" :class="typeClass">
      <div class="toast-content">
        <span class="toast-message">{{ message }}</span>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";

const props = defineProps({
  message: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    default: "info", // success, error, warning, info
  },
  duration: {
    type: Number,
    default: 3000,
  },
});

const emit = defineEmits(["close"]);

const isVisible = ref(false);

const typeClass = computed(() => {
  return `toast-${props.type}`;
});

const show = () => {
  isVisible.value = true;
  window.setTimeout(() => {
    hide();
  }, props.duration);
};

const hide = () => {
  isVisible.value = false;
  window.setTimeout(() => {
    emit("close");
  }, 300);
};

onMounted(() => {
  show();
});
</script>

<!-- <style scoped>
.toast-alert {
  position: fixed;
  top: 20px;
  right: 20px;
  max-width: 400px;
  width: auto;
  height: 56px;
  min-width: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 9998;
  overflow: hidden;
}

.toast-message {
  font-size: 14px;
  line-height: 1.4;
}

/* Toast 타입별 색상 */
.toast-success {
  background-color: #28a745;
}

.toast-error {
  background-color: #dc3545;
}

.toast-warning {
  background-color: #ffc107;
  color: #212529;
}

.toast-info {
  background-color: #17a2b8;
}

/* 애니메이션 */
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.toast-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

@media (max-width: 768px) {
  .toast-alert {
    left: 20px;
    right: 20px;
    max-width: none;
  }
}
</style> -->
